// extracted by mini-css-extract-plugin
export default {"info":"tweet-info_info__oDwC9","infoLink":"tweet-info_infoLink__nfflB","infoIcon":"tweet-info_infoIcon__ywMyD"};